
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M10.9535 3C9.69769 3 6.68374 3.58605 6.34885 5.93023C6.2584 6.56338 6.10484 7.65867 5.91786 9M5.91786 9C5.56478 11.5329 5.09253 14.9431 4.70106 17.7756C4.44559 19.624 2.86595 21 1 21M5.91786 9H10.9535L14.4768 14M5.91786 9H2M14.4768 14L18 19M14.4768 14L19 9M14.4768 14L10 19"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiCalculation",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
